/**
 * Normalise a person name for equality checks (trim and collapse whitespace).
 */
function normalizeComparableName(value: string): string {
    return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

/**
 * Split a full name into first and last parts using the same rule as HDE submit.
 */
function splitFullName(fullName: string): { first: string; last: string } {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    const first = parts[0] ?? '';
    const last = parts.slice(1).join(' ').trim() || first;

    return { first, last };
}

function buildComparableFullName(firstName: string, lastName: string): string {
    return normalizeComparableName(
        `${firstName.trim()} ${lastName.trim()}`.trim(),
    );
}

export interface GuestMustDifferFromPrimaryErrors {
    guestNameError?: string;
    guestEmailError?: string;
}

/**
 * Returns validation errors when guest contact details match the primary registrant.
 */
export function getGuestMustDifferFromPrimaryErrors(
    guestName: string,
    guestEmail: string,
    primaryName: string,
    primaryEmail: string,
): GuestMustDifferFromPrimaryErrors {
    const errors: GuestMustDifferFromPrimaryErrors = {};

    const guestEmailTrimmed = guestEmail.trim();
    const primaryEmailTrimmed = primaryEmail.trim();
    if (
        guestEmailTrimmed.length > 0 &&
        primaryEmailTrimmed.length > 0 &&
        guestEmailTrimmed.toLowerCase() === primaryEmailTrimmed.toLowerCase()
    ) {
        errors.guestEmailError =
            'Guest email must be different from your email address.';
    }

    const guestParts = splitFullName(guestName);
    const primaryParts = splitFullName(primaryName);
    const guestFullName = buildComparableFullName(
        guestParts.first,
        guestParts.last,
    );
    const primaryFullName = buildComparableFullName(
        primaryParts.first,
        primaryParts.last,
    );

    if (
        guestFullName.length > 0 &&
        primaryFullName.length > 0 &&
        guestFullName === primaryFullName
    ) {
        errors.guestNameError = 'Guest name must be different from your name.';
    }

    return errors;
}
